module.exports = __webpack_public_path__ + "static/Elina-Lepomaki-524bbab1fdb050f3dfc881c5b81d2243.jpeg";